import { render, staticRenderFns } from "./TableUnidadesConsumidoras.vue?vue&type=template&id=d489c704"
import script from "./TableUnidadesConsumidoras.vue?vue&type=script&lang=js"
export * from "./TableUnidadesConsumidoras.vue?vue&type=script&lang=js"
import style0 from "./TableUnidadesConsumidoras.vue?vue&type=style&index=0&id=d489c704&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports